import { useAuthStore } from "@/stores/auth.store";

export default (to, from, next) => {

    const auth = useAuthStore()
    if (auth.isLoggedIn) next('/')
    else next()
}
